import React from 'react';
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  useTheme,
} from '@mui/material';
import { tokens } from '../theme';

export const customerOptions = [
  { value: 'ft', label: 'Finanztrends' },
  { value: 'bg', label: 'Börse Global' },
  { value: 'sw', label: 'Stock-World' },
  { value: 'tt', label: 'Trading-Treff' },
  { value: 'be', label: 'Börse-Express' },
  { value: 'foreign', label: 'Foreign Leads' },
];

interface CustomerRadioFilterProps {
  selectedCustomer: string;
  onSelectionChange: (customer: string) => void;
}

const CustomerRadioFilter: React.FC<CustomerRadioFilterProps> = ({
  selectedCustomer,
  onSelectionChange,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSelectionChange(event.target.value);
  };

  return (
    <Box>
      <FormControl component="fieldset">
        <FormLabel
          component="legend"
          sx={{
            color: colors.grey[100],
            fontWeight: 600,
            fontSize: '0.875rem',
            mb: 1,
          }}
        >
          Kunde
        </FormLabel>
        <RadioGroup row value={selectedCustomer} onChange={handleChange} sx={{ gap: 2 }}>
          {customerOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={
                <Radio
                  sx={{
                    color: colors.blueAccent[600],
                    '&.Mui-checked': {
                      color: colors.blueAccent[600],
                    },
                  }}
                />
              }
              label={option.label}
              sx={{
                '& .MuiFormControlLabel-label': {
                  color: colors.grey[100],
                  fontSize: '0.875rem',
                },
              }}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

export default CustomerRadioFilter;
